module.exports = __webpack_public_path__ + "img/leaf_grey.86d55886.svg";